import { AppBar, Button, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
  },
  logoText: {
    fontSize: 16,
    color: theme.palette.common.white,
  },
  logoImg: {
    width: '35px',
    height: '35px',
  },
}));

function Topbar({ className, ...rest }) {
  const classes = useStyles();

  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <img src="/images/logos/logo.svg" className={classes.logoImg} alt="Logo" />
        <Button className={classes.logoText} color="inherit">
          ACE Online
        </Button>
      </Toolbar>
    </AppBar>
  );
}

Topbar.propTypes = {
  className: PropTypes.string,
};

export default Topbar;
